import styled from "@emotion/styled"
import { readableColor } from "polished"
import { Flex } from "@rebass/grid/emotion"

import { rhythm } from "@utils/typography"

const Wrapper = styled(Flex)`
  margin-bottom: ${rhythm(1)};
  width: 100%;
`

const CardBody = styled(Flex)`
  background: ${props =>
    props.background ? props.background : props.theme.backgroundColor};
  color: ${props =>
    props.background
      ? readableColor(props.background)
      : readableColor(props.theme.backgroundColor)};
  padding: ${rhythm(1)};
`

export { CardBody, Wrapper }
